import { UserLearningComponentProps } from './user-learning.model';
import { UserLearningView } from './user-learning.view';

export const UserLearningController: React.FC<UserLearningComponentProps> = (
  props
) => {
  return <UserLearningView {...props} />;
};
